import { render, staticRenderFns } from "./artwork.vue?vue&type=template&id=c22af39a&scoped=true&"
import script from "./artwork.vue?vue&type=script&lang=js&"
export * from "./artwork.vue?vue&type=script&lang=js&"
import style0 from "./artwork.vue?vue&type=style&index=0&id=c22af39a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22af39a",
  null
  
)

export default component.exports